export default {
  setFunnels(state, funnels) {
    state.funnels = funnels;
  },
  setTree(state, tree) {
    state.tree = tree;
  },
  setFunnel(state, funnel) {
    state.funnel = funnel;
  },
  setPagination(state, pagination) {
    state.pagination = pagination;
  }
};
